import {DashboardMachine} from '@models/dashboard/dashboard-machine';

export class DashboardListCategoryMachines {
  machines: Set<DashboardMachine> = new Set<DashboardMachine>();
  machinesCount: number = 0;
}
